import React, { useState, useEffect } from 'react';
import axios from 'axios';

export default function ResetPassword() {
  const [token, setToken] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    setToken(params.get('token') || '');
  }, []);

  const handleSubmit = async () => {
    setError('');
    if (newPassword.length < 8) return setError('Password must be at least 8 characters.');
    if (newPassword !== confirmPassword) return setError('Passwords do not match.');
    try {
      setLoading(true);
      await axios.post(`${process.env.REACT_APP_API_URL}/password/reset`, { token, newPassword });
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      setSuccess(true);
    } catch (err) {
      setError(err.response?.data?.error || 'Invalid or expired link.');
    } finally {
      setLoading(false);
    }
  };

  const inputStyle = { width: '100%', padding: '10px 12px', border: '1px solid #E5E7EB', borderRadius: '6px', fontSize: '13px', color: '#111827', outline: 'none', boxSizing: 'border-box' };

  return (
    <div style={{ minHeight: '100vh', background: '#F3F4F6', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <div style={{ background: '#fff', borderRadius: '12px', padding: '40px', width: '100%', maxWidth: '420px', boxShadow: '0 4px 24px rgba(0,0,0,0.08)' }}>
        {success ? (
          <>
            <h1 style={{ fontSize: '20px', fontWeight: '700', color: '#111827', margin: '0 0 12px 0' }}>Password Updated</h1>
            <p style={{ fontSize: '13px', color: '#6B7280', marginBottom: '24px' }}>Your password has been reset. You can now log in.</p>
            <button onClick={() => { window.location.href = '/'; }} style={{ fontSize:'13px', color:'#1A3A5C', fontWeight:'600', background:'none', border:'none', cursor:'pointer', padding:0 }}>Go to Login</button>
          </>
        ) : (
          <>
            <h1 style={{ fontSize: '20px', fontWeight: '700', color: '#111827', margin: '0 0 8px 0' }}>Reset Password</h1>
            <p style={{ fontSize: '13px', color: '#6B7280', marginBottom: '24px' }}>Enter your new password below.</p>
            {error && <div style={{ background: '#FEF2F2', border: '1px solid #FECACA', borderRadius: '6px', padding: '10px 12px', marginBottom: '16px', fontSize: '12px', color: '#B91C1C' }}>{error}</div>}
            <div style={{ marginBottom: '16px' }}>
              <label style={{ display: 'block', fontSize: '12px', fontWeight: '600', color: '#374151', marginBottom: '6px' }}>New Password</label>
              <input type="password" value={newPassword} onChange={e => setNewPassword(e.target.value)} style={inputStyle} placeholder="Min. 8 characters" />
            </div>
            <div style={{ marginBottom: '24px' }}>
              <label style={{ display: 'block', fontSize: '12px', fontWeight: '600', color: '#374151', marginBottom: '6px' }}>Confirm Password</label>
              <input type="password" value={confirmPassword} onChange={e => setConfirmPassword(e.target.value)} style={inputStyle} placeholder="Re-enter password"
                onKeyDown={e => e.key === 'Enter' && handleSubmit()} />
            </div>
            <button onClick={handleSubmit} disabled={loading} style={{ width: '100%', padding: '11px', background: '#1A3A5C', color: '#fff', border: 'none', borderRadius: '6px', fontSize: '13px', fontWeight: '600', cursor: loading ? 'not-allowed' : 'pointer', opacity: loading ? 0.7 : 1 }}>
              {loading ? 'Updating...' : 'Reset Password'}
            </button>
          </>
        )}
      </div>
    </div>
  );
}
